export const ticketTypes = Object.freeze([
    'Subscription',
    'Regular',
    'Regular discount',
    'Discount',
    'Cancelled',
    'Free',
    'Reserved',
])
